"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        transition: 'all 0.2s ease-in-out',
        background: theme.colors.white
    },
    row: {
        display: 'flex',
        marginTop: '4px',
        gap: '4px'
    },
    legendAndTooltipWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    disabled: {
        cursor: 'not-allowed',
        '& $label': {
            color: theme.colors.gray300
        },
        '& + $helperTextWrapper': {
            color: theme.colors.gray300
        }
    },
    error: {
        borderColor: theme.colors.warningAccessible
    },
    helperTextWrapper: {
        alignItems: 'center',
        display: 'flex',
        padding: ['4px', '0px']
    },
    errorIconWrapper: {
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        marginRight: '4px'
    }
}); });
